// Catálogo de fontes padrío Zebra (ZPL II), matrizes @203 dpi (8 dot/mm).
// Fonte da verdade: tabela oficial "Font Matrices" da doc Zebra.
// ponytail: as matrizes de E (OCR-B) e H (OCR-A) escalam com o DPI — aqui fixadas em 203 dpi.

export const ZEBRA_FONTS = [
  {
    code: '0',
    name: '0 — Escalável (default 15×12)',
    scalable: true,
    type: 'U-L-D',
    previewFamily: 'Arial, Helvetica, sans-serif',
  },
  { code: 'A', name: 'A — 9×5', scalable: false, type: 'U-L-D', matrix: { h: 9, w: 5 }, icg: 1, baseline: 7, previewFamily: 'monospace' },
  { code: 'B', name: 'B — 11×7', scalable: false, type: 'U', matrix: { h: 11, w: 7 }, icg: 2, baseline: 11, previewFamily: 'monospace' },
  { code: 'C', name: 'C — 18×10', scalable: false, type: 'U-L-D', matrix: { h: 18, w: 10 }, icg: 2, baseline: 14, previewFamily: 'monospace' },
  { code: 'D', name: 'D — 18×10', scalable: false, type: 'U-L-D', matrix: { h: 18, w: 10 }, icg: 2, baseline: 14, previewFamily: 'monospace' },
  { code: 'E', name: 'E — OCR-B', scalable: false, type: 'OCR-B', matrix: { h: 28, w: 15 }, icg: 5, baseline: 23, previewFamily: '"OCR-B", "Courier New", monospace' },
  { code: 'F', name: 'F — 26×13', scalable: false, type: 'U-L-D', matrix: { h: 26, w: 13 }, icg: 3, baseline: 21, previewFamily: 'monospace' },
  { code: 'G', name: 'G — 60×40', scalable: false, type: 'U-L-D', matrix: { h: 60, w: 40 }, icg: 8, baseline: 48, previewFamily: 'monospace' },
  { code: 'H', name: 'H — OCR-A', scalable: false, type: 'OCR-A', matrix: { h: 21, w: 13 }, icg: 6, baseline: 21, previewFamily: '"OCR-A", "Courier New", monospace' },
  { code: 'GS', name: 'GS — Símbolo 24×24', scalable: false, type: 'SYMBOL', matrix: { h: 24, w: 24 }, icg: null, baseline: null, previewFamily: 'monospace' },
  { code: 'P', name: 'P — 20×18', scalable: false, type: 'U-L-D', matrix: { h: 20, w: 18 }, icg: null, baseline: null, previewFamily: 'monospace' },
  { code: 'Q', name: 'Q — 28×24', scalable: false, type: 'U-L-D', matrix: { h: 28, w: 24 }, icg: null, baseline: null, previewFamily: 'monospace' },
  { code: 'R', name: 'R — 35×31', scalable: false, type: 'U-L-D', matrix: { h: 35, w: 31 }, icg: null, baseline: null, previewFamily: 'monospace' },
  { code: 'S', name: 'S — 40×35', scalable: false, type: 'U-L-D', matrix: { h: 40, w: 35 }, icg: null, baseline: null, previewFamily: 'monospace' },
  { code: 'T', name: 'T — 48×42', scalable: false, type: 'U-L-D', matrix: { h: 48, w: 42 }, icg: null, baseline: null, previewFamily: 'monospace' },
  { code: 'U', name: 'U — 59×53', scalable: false, type: 'U-L-D', matrix: { h: 59, w: 53 }, icg: null, baseline: null, previewFamily: 'monospace' },
  { code: 'V', name: 'V — 80×71', scalable: false, type: 'U-L-D', matrix: { h: 80, w: 71 }, icg: null, baseline: null, previewFamily: 'monospace' },
];

function fontCode(font) {
  if (font == null) return '0';
  if (typeof font === 'string') return font.toUpperCase();
  if (typeof font === 'object' && font.name != null) return String(font.name).toUpperCase();
  return '0';
}

export function resolveFont(font) {
  const code = fontCode(font);
  return ZEBRA_FONTS.find((item) => item.code === code) ?? ZEBRA_FONTS[0];
}

export function isScalable(font) {
  return resolveFont(font).scalable;
}

// Fonte fora do catálogo padrío = fonte baixada na impressora.
export function isStandardFont(font) {
  const code = fontCode(font);
  return ZEBRA_FONTS.some((item) => item.code === code);
}

export function fontMatrix(font) {
  return resolveFont(font).matrix ?? null;
}

// Avanço (em dots) de um caractere na fonte: largura da matriz + intercharacter gap.
export function fontAdvanceDots(font) {
  const resolved = resolveFont(font);
  if (!resolved.matrix) return 0;
  return resolved.matrix.w + (resolved.icg ?? 0);
}
